// Imports Defined
// import { Container, Row } from 'react-bootstrap';
import BannerSingleImage from '../bannerSingleImage/BannerSingleImage';
import icon1 from '../../../assets/images/png/pics/icon1.png';
import icon2 from '../../../assets/images/png/pics/icon2.png';
import icon3 from '../../../assets/images/png/pics/icon3.png';
import icon4 from '../../../assets/images/png/pics/icon4.png';
import icon5 from '../../../assets/images/png/pics/icon5.png';
import icon6 from '../../../assets/images/png/pics/icon6.png';
import icon7 from '../../../assets/images/png/pics/icon7.png';
import './bannerOverlay.css';

function BannerOverlay() {
  return (
    <section className="bannerComponent__Container">
      <BannerSingleImage
        img={icon1}
        // bgimg={icon1bg}
        classNams="iconsOfBanner icon1"
      />
      <BannerSingleImage img={icon2} className="iconsOfBanner icon2" />
      <BannerSingleImage img={icon3} className="iconsOfBanner icon3" />
      <BannerSingleImage img={icon5} className="iconsOfBanner icon4" />
      <BannerSingleImage
        img={icon4}
        // bgimg={icon4bg}
        className="iconsOfBanner icon5"
      />
      <BannerSingleImage
        img={icon6}
        // bgimg={icon6bg}
        className="iconsOfBanner icon6"
      />
      <BannerSingleImage
        img={icon7}
        // bgimg={icon7bg}
        className="iconsOfBanner icon7"
      />
    </section>
  );
}

export default BannerOverlay;
